import React from "react";
import PropTypes from 'prop-types';
import FormattedAchievementTimes from './FormattedAchievementTimes.jsx'

const FormattedAchievementResult =({Component='span', allowNull = false, result, achievement}) => {

    if (!result) {
        return allowNull ? null : <Component>{'\u00A0'}</Component>;
    }

    if (result.times == result.points) {
        return <Component>{result.points}</Component>;
    }


    return <Component>{<FormattedAchievementTimes achievementResult={result} achievement={achievement}/>}{` (${result.points})`}</Component>;
};


FormattedAchievementResult.propTypes = {
    result: PropTypes.shape({
        times: PropTypes.number.isRequired,
        points: PropTypes.number.isRequired,
    }),
    achievement: PropTypes.shape({
        valueType: PropTypes.string.isRequired
        }
    ).isRequired,
    Component: PropTypes.any,
    allowNull: PropTypes.bool
};

export default FormattedAchievementResult;